// extracted by mini-css-extract-plugin
module.exports = {"container":"Answer_container__32-IR","Disclaimer":"Answer_Disclaimer__2d_3u","Main":"Answer_Main__2QjQX","Image":"Answer_Image__2usH7"};